// Import custom scripts and files
import './plugins/Craft';
import './plugins/CookieConsent';
import Alpine from 'alpinejs';
import '@tailwindplus/elements';
import initGlobalJS from './components/GlobalJs';
import initHeader from './components/Header';
import initFooter from './components/Footer';
import initHeroSlider from './components/HeroSlider';
import initProductSlider from './components/ProductSlider';
import initProductDetails from './components/ProductDetails';
import initImageZoom from './components/ImageZoom';
import initPageNavigation from './components/PageNavigation';
import initAccordion from './components/Accordion';
import initProductCard from './components/ProductCard';
import initShipping from './components/Shipping';
import initQuicklinks from './components/Quicklinks';
import initTipProduct from './components/TipProduct';
import initLineItem from './components/LineItem';
import initPayment from './components/Payment';
import initOpenClose from './components/OpenClose';
import initNewsletterForm from './components/NewsletterForm';

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  Alpine.store('shippingMethodReady', true);
  Alpine.store('shippingMethodSaving', false);
  initGlobalJS();
  initHeader();
  initFooter();
  initHeroSlider();
  initProductSlider();
  initProductDetails();
  initImageZoom();
  initPageNavigation();
  initAccordion();
  initProductCard();
  initTipProduct();
  initShipping();
  initPayment();
  initQuicklinks();
  initLineItem();
  initOpenClose();
  initNewsletterForm();
});

Alpine.start();
